
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_qk1j1_157db_93",
  "textarea": "awsui_textarea_qk1j1_157db_97",
  "textarea-readonly": "awsui_textarea-readonly_qk1j1_157db_123",
  "textarea-invalid": "awsui_textarea-invalid_qk1j1_157db_159"
};
  